import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getApiOrigin } from "../config/env";

function prepareHeaders(headers, { getState }) {
  const token = getState().auth?.accessToken;
  if (token) {
    headers.set("Authorization", `Bearer ${token}`);
  }
  const pagePath = currentPagePath();
  if (pagePath) {
    headers.set("X-Page-Path", pagePath);
  }
  return headers;
}

/** SPA route (pathname + search) so the API can tag logs by web page. */
function currentPagePath() {
  if (typeof window === "undefined" || !window.location) {
    return "";
  }
  const path = `${window.location.pathname || ""}${window.location.search || ""}`;
  const trimmed = path.trim();
  if (!trimmed.startsWith("/")) {
    return "";
  }
  return trimmed.length > 200 ? trimmed.slice(0, 200) : trimmed;
}

/**
 * Resolves relative paths against the API origin on every request so /login always
 * targets the backend API host, not the CRA dev server (:3000).
 */
async function baseQuery(args, api, extraOptions) {
  const origin = getApiOrigin();
  const raw = typeof args === "string" ? args : args.url;
  const isAbsolute = /^https?:\/\//i.test(raw);

  let url = raw;
  if (!isAbsolute && origin && origin !== "/") {
    const path = raw.startsWith("/") ? raw : `/${raw}`;
    url = `${origin.replace(/\/+$/, "")}${path}`;
  }

  const next = typeof args === "string" ? url : { ...args, url };

  return fetchBaseQuery({
    baseUrl: "/",
    prepareHeaders,
  })(next, api, extraOptions);
}

export const baseApi = createApi({
  reducerPath: "api",
  baseQuery,
  tagTypes: [
    "ClientConfigurationCustomer",
    "ClientConfigurationJacketJobs",
    "ClientConfigurationContracts",
    "ClientConfigurationContractServices",
    "ClientConfigurationInvProfiles",
    "ClientConfigurationInvProfileDetails",
    "UserActivityRecent",
    "UserActivityEvents",
    "RolePrivileges",
    "RolePrivilegeCatalog",
    "AssignableEmployees",
    "AuthProfile",
    "ServerLogs",
    "ClientInvoiceDraft",
    "ClientInvoiceList",
    "ClientInvoicePcrLinks",
    "ServiceCatalog",
  ],
  endpoints: () => ({}),
});
